import { formatAmount } from "@/lib/utils";

const useOCPFeeTypes = () => {
  // Define Table Columns
  const columns = [
    {
      accessorKey: "feeCode",
      header: "Fee Code",
      accessorFn: (row: any) => String(row?.feeCode || ""),
    },
    {
      accessorKey: "defaultAmount",
      header: "Amount",
      accessorFn: (row: any) => formatAmount(row?.defaultAmount || "0"),
    },
    {
      accessorKey: "displayOrder",
      header: "Display Order",
      accessorFn: (row: any) => String(row?.displayOrder || ""),
    },
  ];

  return {
    columns
  };
};

export default useOCPFeeTypes;
